// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  padding: 3% 5%;
}
nav .nav__menu {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 70%;
  font-size: 1.35rem;
  margin-top: -2%;
}
nav .nav__menu .nav_phone {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
nav .nav__menu p {
  font-size: 1.2rem;
  font-weight: 500;
  cursor: pointer;
}
nav .nav__menu p:hover {
  color: #e63b11;
}
nav .nav__menu a {
  text-decoration: none;
  color: #000;
}
@media (min-width: 1440px) and (max-width: 1900px) {
  nav img {
    width: 25%;
  }
  nav .nav__menu h4 {
    font-size: 1.2rem;
  }
  nav .nav__menu .nav_phone {
    font-size: 1rem;
  }
}
@media (min-width: 691px) and (max-width: 850px) {
  nav {
    width: 100%;
  }
  nav img {
    width: 22%;
  }
  nav .nav__menu {
    width: 80%;
  }
  nav .nav__menu h4 {
    font-size: 0.9rem;
  }
  nav .nav__menu .nav_phone {
    font-size: 0.8rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  nav {
    width: 90%;
  }
  nav img {
    width: 24%;
  }
  nav .nav__menu h4 {
    font-size: 1.2rem;
  }
  nav .nav__menu .nav_phone {
    font-size: 1rem;
  }
}
@media (min-width: 1301px) and (max-width: 1439px) {
  nav {
    width: 90%;
  }
  nav .nav__menu h4 {
    font-size: 1.1rem;
  }
  nav .nav__menu .nav_phone {
    font-size: 1rem;
  }
}
@media (max-width: 690px) {
  nav {
    justify-content: space-between;
  }
  nav img {
    width: 80%;
  }
  nav .menu_icon {
    font-size: 3rem;
    margin: -5% -4% 1% 0;
  }
  nav .mobile_menu {
    position: absolute;
    top: 550%;
    left: 50%;
    margin-right: 40px;
    transform: translate(-50%, -50%);
    width: 99vw;
    height: 100vh;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    z-index: 100;
  }
  nav .mobile_menu img {
    width: 20%;
    margin-bottom: 10%;
  }
  nav .mobile_menu h4 {
    font-size: 1.5rem;
    border-bottom: 2px solid #e63b11;
    width: 50%;
    text-align: center;
    padding-bottom: 4%;
    margin-top: 0;
  }
  nav .mobile_menu a {
    text-decoration: none;
    color: #000;
    font-size: 1.5rem;
    width: 100%;
    text-align: center;
    margin-left: 50%;
    padding-bottom: 4%;
  }
  nav .mobile_menu .mobile_menu_icon {
    align-self: flex-end;
    color: #e63b11;
    font-size: 2.5rem;
  }
}

footer {
  width: 98.5vw;
  border-top: 5px solid #e63b11;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 10%;
  overflow-x: hidden;
}
footer .footer__details {
  width: 100%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  align-items: center;
  align-content: center;
  flex-wrap: nowrap;
}
footer .footer__details .footer_links {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
footer .footer__details .footer_links p {
  opacity: 0.8;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 1rem;
}
footer .footer__details .footer_links h6 {
  color: #e63b11;
  font-size: 1.2rem;
  text-transform: uppercase;
  margin-bottom: 0;
}
footer .footer__details .footer_social_links p {
  opacity: 0.8;
  margin-bottom: 0;
  cursor: pointer;
  font-size: 1rem;
}
footer .footer__details .footer_social_links h6 {
  color: #e63b11;
  font-size: 1.2rem;
  text-transform: uppercase;
  margin-bottom: 0;
}
footer .footer__details .footer_social_links .footer_socials {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 5%;
  padding: 5%;
}
footer .footer__details .footer_social_links .footer_socials .footer_icon {
  font-size: 2rem;
  color: #000;
  transition: ease-in-out 1s;
  cursor: pointer;
}
footer .footer__details .footer_social_links .footer_socials .footer_icon:hover {
  color: #e63b11;
}
footer p {
  opacity: 0.8;
  font-size: 0.9rem;
  text-align: center;
}
footer p a {
  color: #e63b11;
  text-decoration: none;
}
@media (min-width: 691px) and (max-width: 850px) {
  footer .footer__details {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
  }
  footer .footer__details .footer_links {
    flex: 1 1;
    min-width: 250px;
  }
  footer .footer__details .footer_links p {
    font-size: 1.5rem;
  }
  footer .footer__details p {
    font-size: 1.5rem;
  }
}
@media (min-width: 851px) and (max-width: 1000px) {
  footer .footer__details {
    width: 100%;
    flex-wrap: wrap;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  footer .footer__details .footer_links {
    flex: 1 1;
    min-width: 250px;
  }
  footer p {
    font-size: 0.7rem;
  }
}
@media (max-width: 690px) {
  footer .footer__details {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  footer .footer__details img {
    width: 80%;
  }
  footer .footer__details .footer_links {
    width: 100%;
  }
  footer .footer__details .footer_links p {
    font-size: 1.2rem;
  }
  footer .footer__details .footer_links h6 {
    font-size: 0.8rem;
  }
  footer .footer__details .footer_social_links p {
    font-size: 1rem;
  }
  footer .footer__details .footer_social_links h6 {
    font-size: 1.2rem;
  }
  footer .footer__details .footer_social_links .footer_socials {
    font-size: 1rem;
  }
  footer p {
    font-size: 0.8rem;
    width: 70%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/styles/navigation.scss","webpack://./src/components/styles/variables.scss"],"names":[],"mappings":"AAEA;EC+DI,aAAA;EACA,mBAAA;EACA,8BAAA;ED/DA,WAAA;EACA,kBAAA;EACA,cAAA;AACJ;AAAI;EC8CA,aAAA;EACA,mBAAA;EACA,6BAAA;ED9CI,UAAA;EACA,kBAAA;EACA,eAAA;AAIR;AAHQ;ECiEJ,aAAA;EACA,mBAAA;EACA,uBAAA;EDjEQ,iBAAA;AAOZ;AALQ;EACI,iBAAA;EACA,gBAAA;EACA,eAAA;AAOZ;AANY;EACI,cCpBP;AD4BT;AALQ;EACI,qBAAA;EACA,WAAA;AAOZ;AAJI;EACI;IACI,UAAA;EAMV;EAHM;IACI,iBAAA;EAKV;EAHM;IACI,eAAA;EAKV;AACF;AAFI;EAxCJ;IAyCQ,WAAA;EAKN;EAJM;IACI,UAAA;EAMV;EAJM;IACI,UAAA;EAMV;EALU;IACI,iBAAA;EAOd;EALU;IACI,iBAAA;EAOd;AACF;AAJI;EAvDJ;IAwDQ,UAAA;EAON;EANM;IACI,UAAA;EAQV;EALU;IACI,iBAAA;EAOd;EALU;IACI,eAAA;EAOd;AACF;AAJI;EArEJ;IAsEQ,UAAA;EAON;EALU;IACI,iBAAA;EAOd;EALU;IACI,eAAA;EAOd;AACF;AAJI;EAhFJ;IAiFQ,8BAAA;EAON;EANM;IACI,UAAA;EAQV;EANM;IACI,eAAA;IACA,oBAAA;EAQV;EANM;IACI,kBAAA;IACA,SAAA;IACA,SAAA;IACA,kBAAA;IACA,gCAAA;IACA,WAAA;IACA,aAAA;IACA,sBAAA;ICnER,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,2BAAA;IDkEQ,YAAA;EAWV;EAVU;IACI,UAAA;IACA,kBAAA;EAYd;EAVU;IACI,iBAAA;IACA,gCAAA;IACA,UAAA;IACA,kBAAA;IACA,kBAAA;IACA,aAAA;EAYd;EAVU;IACI,qBAAA;IACA,WAAA;IACA,iBAAA;IACA,WAAA;IACA,kBAAA;IACA,gBAAA;IACA,kBAAA;EAYd;EAVU;IACI,oBAAA;IACA,cC5HP;ID6HO,iBAAA;EAYd;AACF;;AAPA;EACI,aAAA;EACA,6BAAA;EC/FA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;ED8FA,cAAA;EACA,kBAAA;AAaJ;AAZI;EACI,WAAA;EACA,cAAA;ECvFJ,aAAA;EACA,mBAAA;EACA,6BAAA;EDuFI,mBAAA;EACA,qBAAA;EACA,iBAAA;AAgBR;AAVQ;EC/GJ,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AD4HJ;AAdY;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAgBhB;AAdY;EACI,cC9JP;ED+JO,iBAAA;EACA,yBAAA;EACA,gBAAA;AAgBhB;AAXY;EACI,YAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;AAahB;AAXY;EACI,cC7KP;ED8KO,iBAAA;EACA,yBAAA;EACA,gBAAA;AAahB;AAXY;EACI,WAAA;EC/HZ,aAAA;EACA,mBAAA;EACA,6BAAA;ED+HY,OAAA;EACA,WAAA;AAehB;AAdgB;EACI,eAAA;EACA,WAAA;EACA,0BAAA;EACA,eAAA;AAgBpB;AAfoB;EACI,cC7Lf;AD8MT;AAXI;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;AAaR;AAZQ;EACI,cCxMH;EDyMG,qBAAA;AAcZ;AAXI;EACI;IACI,WAAA;ICxKR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;IDuKQ,eAAA;EAgBV;EAfU;IACI,SAAA;IACA,gBAAA;EAiBd;EAVc;IACI,iBAAA;EAYlB;EATU;IACI,iBAAA;EAWd;AACF;AARI;EACI;IACI,WAAA;IACA,eAAA;IChMR,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;ED2MF;EAZU;IACI,SAAA;IACA,gBAAA;EAcd;EALM;IACI,iBAAA;EAOV;AACF;AALI;EACI;IClNJ,aAAA;IACA,sBAAA;IACA,mBAAA;IACA,uBAAA;ED0NF;EATU;IACI,UAAA;EAWd;EATU;IACI,WAAA;EAWd;EAVc;IACI,iBAAA;EAYlB;EAVc;IACI,iBAAA;EAYlB;EAPc;IACI,eAAA;EASlB;EAPc;IACI,iBAAA;EASlB;EAPc;IACI,eAAA;EASlB;EALM;IACI,iBAAA;IACA,UAAA;EAOV;AACF","sourcesContent":["@import './variables.scss';\n\nnav{\n    @include rowBetween;\n    width: 100%;\n    position: relative;\n    padding: 3% 5% ;\n    .nav__menu{\n        @include rowEven;\n        width: 70%;\n        font-size: 1.35rem;\n        margin-top: -2%;\n        .nav_phone{\n            @include rowCenter;\n            font-size: 1.20rem;\n        }\n        p{\n            font-size: 1.2rem;\n            font-weight: 500;\n            cursor: pointer;\n            &:hover{\n                color: $orange\n            }\n        }\n        a{\n            text-decoration: none;\n            color: #000;    \n        }\n    }\n    @media(min-width: $smallScreen) and (max-width:1900px){\n        img{\n            width: 25%;\n        }\n       .nav__menu{\n        h4{\n            font-size: 1.2rem;\n        }\n        .nav_phone{\n            font-size: 1rem;\n        }\n       } \n    }\n    @media(min-width: $tabletMin) and (max-width: $tabletMax){\n        width: 100%;\n        img{\n            width: 22%;\n        }\n        .nav__menu{\n            width: 80%;\n            h4{\n                font-size: 0.9rem;\n            }\n            .nav_phone{\n                font-size: 0.8rem;\n            }\n        }\n    }\n    @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n        width: 90%;\n        img{\n            width: 24%;\n        }\n        .nav__menu{\n            h4{\n                font-size: 1.2rem;\n            }\n            .nav_phone{\n                font-size: 1rem;;\n            }\n        }\n    }\n    @media(min-width: $smallLaptopMin) and (max-width: $smallLaptopMax){\n        width: 90%;\n        .nav__menu{\n            h4{\n                font-size: 1.1rem;\n            }\n            .nav_phone{\n                font-size: 1rem;\n            }\n        }\n    }\n    @media (max-width: $mobile){\n        justify-content: space-between;\n        img{\n            width: 80%;\n        }\n        .menu_icon{\n            font-size: 3rem;\n            margin: -5% -4% 1% 0;\n        }\n        .mobile_menu{\n            position: absolute;\n            top:550%;\n            left: 50%;\n            margin-right: 40px;\n            transform: translate(-50%, -50%);\n            width: 99vw;\n            height: 100vh;\n            background-color: #fff;\n            @include columnStartCenter;\n            z-index: 100;\n            img{\n                width: 20%;\n                margin-bottom: 10%;\n            }\n            h4{\n                font-size: 1.5rem;\n                border-bottom: 2px solid $orange;\n                width: 50%;\n                text-align: center;\n                padding-bottom: 4%;\n                margin-top: 0;\n            }\n            a{\n                text-decoration: none;\n                color: #000;\n                font-size: 1.5rem;\n                width: 100%;\n                text-align: center;\n                margin-left: 50%;\n                padding-bottom: 4%;\n            }       \n            .mobile_menu_icon{\n                align-self: flex-end;\n                color: $orange;\n                font-size: 2.5rem;\n            }\n        }\n    }\n}\n\nfooter{\n    width: 98.5vw;\n    border-top: 5px solid $orange;\n    @include columnStack;\n    padding: 0 10%;\n    overflow-x: hidden;\n    .footer__details{\n        width: 100%;\n        margin: 0 auto;\n        @include rowEven;\n        align-items: center;\n        align-content: center;\n        flex-wrap: nowrap;\n        img {\n            // margin-top: 10px;\n            // width: 20%;\n        }\n        \n        .footer_links{\n            @include columnStack;\n            p{\n                opacity: .8;\n                margin-bottom: 0;\n                cursor: pointer;\n                font-size: 1rem;\n            }\n            h6{\n                color: $orange;\n                font-size: 1.2rem;\n                text-transform: uppercase;\n                margin-bottom: 0;\n            }\n           \n        }\n        .footer_social_links{\n            p{\n                opacity: .8;\n                margin-bottom: 0;\n                cursor: pointer;\n                font-size: 1rem;\n            }\n            h6{\n                color: $orange;\n                font-size: 1.2rem;\n                text-transform: uppercase;\n                margin-bottom: 0;\n            }\n            .footer_socials{\n                width: 100%;\n                @include rowEven;\n                gap:5%;\n                padding: 5%;\n                .footer_icon{\n                    font-size: 2rem;\n                    color:#000;\n                    transition: ease-in-out 1s;\n                    cursor: pointer;\n                    &:hover{\n                        color: $orange;\n                    }\n                }\n            }\n        }\n    }\n    p{\n        opacity: .8;\n        font-size: .9rem;\n        text-align: center;\n        a{\n            color: $orange;\n            text-decoration: none;\n        }\n    }\n    @media(min-width: $tabletMin) and (max-width: $tabletMax){\n        .footer__details{\n            width: 100%;\n            @include columnStack;\n            flex-wrap: wrap;\n            .footer_links{\n                flex:1;\n                min-width: 250px;\n                // p{\n                //     font-size: .9rem;\n                // }\n                // h6{\n                //     font-size: 1rem;\n                // }\n                p{\n                    font-size: 1.5rem;\n                }\n            }\n            p{\n                font-size: 1.5rem;\n            }\n        }\n    }\n    @media(min-width: $landsTabletMin) and (max-width: $landsTabletMax){\n        .footer__details{\n            width: 100%;\n            flex-wrap: wrap;\n            @include columnStack;\n            .footer_links{\n                flex:1;\n                min-width: 250px;\n                // p{\n                //     font-size: .9rem;\n                // }\n                // h6{\n                //     font-size: 1rem;\n                // }\n            }\n        }\n        p{\n            font-size: 0.7rem;\n        }\n    }\n    @media(max-width: $mobile){\n        .footer__details{\n            @include columnStack;\n            img{\n                width: 80%;\n            }\n            .footer_links{\n                width: 100%;\n                p{\n                    font-size: 1.2rem;\n                }\n                h6{\n                    font-size: .8rem;\n                }\n                \n            }\n            .footer_social_links{\n                p{\n                    font-size: 1rem;\n                }\n                h6{\n                    font-size: 1.2rem;\n                }\n                .footer_socials{\n                    font-size: 1rem;\n                }\n            }\n        }\n        p{\n            font-size: 0.8rem;\n            width:70%;\n        }\n    }\n}","//colours\n$orange: #e63b11;\n$font: #000;\n$lightGrey: #d1d3d4;\n$darkGrey: #939598;\n$darkBlue: #01426a;\n$lightBlue: #77c5d5;\n\n//mobile breaks\n$mobilemin:100;\n$mobile: 690px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1000px;\n$landsTabletMin2: 1000px;\n$landsTabletMax2: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@mixin columnStart{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin columnStartCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin columnStack{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnCenter{\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin rowEven{\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowEvenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n\n@mixin rowBetween{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart{\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin button {\n        background-color: $orange;\n        color: #fff;\n        text-transform: uppercase;\n        border: none;\n        // height: 3rem;\n        border-radius: 1.5rem;\n        letter-spacing: 0.1rem;\n        font-weight: 600;\n        // margin: 3% auto;\n        transition: background-color 0.3s ease;\n        padding: 0 2rem;\n        cursor: pointer;\n        \n        &:hover {\n          background-color: #000;\n        }\n      \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
